import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BodyTextContainerComponent } from '@dynamic-components/body-text-container';
import { JbCalloutBlockContainerModule } from '@dynamic-components/callout-block-container';
import { ImageContainerModule } from '@dynamic-components/image-container';
import { IsolatedFlightBlockContainerModule } from '@dynamic-components/isolated-flight-block-container/isolated-flight-block-container.module';
import { TableContainerModule } from '@dynamic-components/table-container';
import { VideoContainerModule } from '@dynamic-components/video-container';
import { RendererTemplateComponent } from '@dynamic-templates/renderer-template/renderer-template.component';
import { BookerModule } from '@shared/booker/booker.module';
import { StaticBookerPodModule } from '@shared/static-booker-pod';
import { PipesModule, UIModule } from '@shared/ui';
import {
  JbDialogLinkModule,
  JbProductBlockModule,
  JbStarRatingModule,
  JbTabsModule,
  JbUtilsModule,
} from 'jb-component-library';

import { BodyTextImageContainerModule } from '../../body-text-image-container/body-text-image-container.module';
import { TabComponent, tabComponentResolver } from './tab-component.component';

const MODULES = [
  CommonModule,
  UIModule,
  JbTabsModule,
  BodyTextImageContainerModule,
  BodyTextContainerComponent,
  JbProductBlockModule,
  JbUtilsModule,
  JbStarRatingModule,
  JbDialogLinkModule,
  BookerModule,
  TableContainerModule,
  StaticBookerPodModule,
  ImageContainerModule,
  VideoContainerModule,
  JbCalloutBlockContainerModule,
  PipesModule,
  IsolatedFlightBlockContainerModule,
  RendererTemplateComponent,
];

const DECLARATIONS = [TabComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class TabComponentModule {
  static entry = TabComponent;
  static componentDataResolver = tabComponentResolver;
}
